export default __webpack_public_path__ + "static/media/img_lunwen.da8d6b82.png";